import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { store as mainAppStore } from '@edf-pkg/app-main';

import Loading from '$app-web/components/loading';
import asSpace from '$app-web/hoces/as-space';
import RdashModule from '$app-web/modules/rdash';

import * as dashboardStore from './store';

export const SPACE_ID = 'dashboard';

dashboardStore.inject();

const DashboardSpace = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const isLogoutLoading = useSelector(mainAppStore.userDuck.duckSelectors.logoutStatusLoadingSelector);
    const isLogoutFailed = useSelector(mainAppStore.userDuck.duckSelectors.logoutStatusFailedSelector);

    return (
        <>
            <Loading
                variant="modal"
                errorHasButton
                onErrorButtonClick={() => dispatch(mainAppStore.userDuck.duckActionCreators.logout())}
                errorButtonText={t('try_again')}
                loading={isLogoutLoading}
                error={isLogoutFailed}
            />
            <RdashModule />
        </>
    );
};

export default asSpace()(DashboardSpace);

export { dashboardStore };
